import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
    methods: {
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
        // 获取套餐资源包明细 D1套餐（503）D2套餐（504）D套餐开课（1012）2017Q4会销开课（1008）
        getDetailsPackage(PackageId, SubjectId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                PackageId: PackageId,
                SubjectId: SubjectId //英语94 艺术102
            };
            this.loading = true;
            $http.get("api/ContinueOrder/GetPackageDetailById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                //this.Hipackages = []
                util.doResult(this, res, () => {
                    //this.Hipackages = Data
                    let len = Data.length
                    if (PackageId == 1008) {
                        // hi幼教英语 D1套餐（503）D套餐开课（1012）2017Q4会销开课（1008）
                        for (let i = 0; i < len; i++) {
                            this.Hipackages.push({
                                ProId: Data[i].ProId,
                                ProName: Data[i].ProName,
                                ProNum: 0
                            })
                        }
                        this.HipackagesStore = cloneDeep(this.Hipackages)
                    }
                    if (PackageId == 5031) {
                        // 获取艺术资源包D1套餐（503）
                        for (let i = 0; i < len; i++) {
                            this.Artpackages.push({
                                ProId: Data[i].ProId,
                                ProName: Data[i].ProName,
                                ProNum: 0
                            })
                        }
                        this.ArtpackagesStore = cloneDeep(this.Artpackages)

                    }
                    if (PackageId == 5041) {
                        // 获取艺术资源包D2套餐（504）
                        for (let i = 0; i < len; i++) {
                            this.Bookpackages.push({
                                ProId: Data[i].ProId,
                                ProName: Data[i].ProName,
                                ProNum: 0
                            })
                        }
                        this.BookpackagesStore = cloneDeep(this.Bookpackages)
                    }
                });
            });
        },
        // 获取开课详情
        GetOpenClassInfoBySchoolId(SchoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: SchoolId,
            };
            // 修改需要再传 OrderId
            //console.log(!this.showData.isReadOnly)
            if (this.showData.title == '修改订单') {
                params.OrderId = this.form.OrderId
            }

            $http.get("api/MeetOrder/GetOpenClassInfoBySchoolId", params).then(res => {

                let {
                    Data,
                    Cnt
                } = res.data;
                this.packageDetails = []
                util.doResult(this, res, () => {
                    let len = Data.length
                    // 获取开课详情

                    for (let i = 0; i < len; i++) {
                        this.packageDetails.push({
                            PackageId: Data[i].PackageId,
                            ProName: Data[i].PackageName,
                            ProNum1: Data[i].ClassNum,
                            ProNum2: Data[i].OpenClassNum,
                            ProNum: 0,
                            maxNum: Data[i].SurplusOpenClassNum
                        })
                        this.PackageBox = cloneDeep(this.packageDetails)
                        // 获取D1分期，全款开课数
                        if (Data[i].PackageId == 5031) {
                            let len2 = Data[i].List.length
                            let $obj = Data[i].List
                            for (let j = 0; j < len2; j++) {
                                if ($obj[j].ChargeType == 2) {
                                    // 全款
                                    this.StorageNum.typeOneClassNumAll = $obj[j].CourseNum
                                } else {
                                    // 分期
                                    this.StorageNum.typeOneClassNumFen = $obj[j].CourseNum
                                }
                            }
                        }
                        // 获取D2分期，全款开课数
                        if (Data[i].PackageId == 5041) {
                            let len2 = Data[i].List.length
                            let $obj = Data[i].List
                            for (let j = 0; j < len2; j++) {
                                if ($obj[j].ChargeType == 2) {
                                    // 全款
                                    this.StorageNum.typeTwoClassNumAll = $obj[j].CourseNum
                                } else {
                                    // 分期
                                    this.StorageNum.typeTwoClassNumFen = $obj[j].CourseNum
                                }
                            }
                        }
                    }
                });
            });
        },
        // 查看/修改获取单条
        getList(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            $http.get("api/MeetOrder/GetOpenClassApplyById", params).then(res => {
                jToast.close();
                this.AddDialogVisible = true
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {

                    this.form = util.filterAndSetData(this.form, Data) //过滤数据
                    console.log(this.form)
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress //收货地址
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel //联系人及电话
                    if (Data.IsTransfer == 1) {
                        // 转园订单
                        this.form.OldSchoolId = Data.OldSchoolId
                        this.form.IsTransfer = Data.IsTransfer

                    }
                    // 匹配开课详情ListClassNum
                    // console.log(this.packageDetails)

                    for (let i = 0; i < Data.ListClassNum.length; i++) {
                        for (let j = 0; j < this.packageDetails.length; j++) {
                            if (Data.ListClassNum[i].PackageId == this.packageDetails[j].PackageId) {

                                this.packageDetails[j].ProNum = Data.ListClassNum[i].ClassNum

                            }
                        }

                    }


                    // 获取资源包数据
                    let len = Data.GoodsList.length
                    let $obj = Data.GoodsList
                    for (let i = 0; i < len; i++) {
                        if ($obj[i].PackageId !== 5041 && $obj[i].SubjectId == 94) {
                            // hi幼教英语
                            this.Hipackages = []
                            this.Hipackages = cloneDeep($obj[i].List)
                            console.log(this.Hipackages)
                        } else if ($obj[i].SubjectId == 102) {
                            // 艺术
                            this.Artpackages = []
                            this.Artpackages = cloneDeep($obj[i].List)
                        } else {
                            // 智趣坞英语
                            this.Bookpackages = []
                            this.Bookpackages = cloneDeep($obj[i].List)
                        }
                    }

                    this.form.Remark = Data.OrderRemark
                    this.payList = cloneDeep(Data.PayList)
                    this.PayListData = cloneDeep(Data.PayList)

                    this.schoolConsignee.Consignee = Data.SchoolConsignee
                    this.schoolConsignee.ConsigneeAddress = Data.SchoolAddress
                    this.schoolConsignee.ConsigneeAreaId = Data.SchoolAreaId
                    this.schoolConsignee.ConsigneeCityId = Data.SchoolCityId
                    this.schoolConsignee.ConsigneeProvId = Data.SchoolProvincesId
                    this.schoolConsignee.ConsigneeTel = Data.SchoolConsigneeTel
                });
            });
        },
        // 获取收货地址
        getSchoolConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };

            $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.SchoolConsigneeList = Data;
                    for (let i = 0; i < this.SchoolConsigneeList.length; i++) {
                        //IsDefault==1为默认地址

                        if (this.SchoolConsigneeList[i].IsDefault == 1) {

                            this.ConsigneeList = this.SchoolConsigneeList[i].ConsigneeProvinceName + '  ' + this.SchoolConsigneeList[i].ConsigneeCityName + '  ' + this.SchoolConsigneeList[i].ConsigneeAreaName + '  ' + this.SchoolConsigneeList[i].ConsigneeAdress
                            this.ConsigneeListName = this.SchoolConsigneeList[i].Consignee + '  ' + this.SchoolConsigneeList[i].ConsigneeTel
                            this.form.SchoolConsigneeId = this.SchoolConsigneeList[i].Id

                            //设置地址
                            this.schoolConsignee.ConsigneeProvId = this.SchoolConsigneeList[i].ConsigneeProvince
                            this.schoolConsignee.ConsigneeCityId = this.SchoolConsigneeList[i].ConsigneeCity
                            this.schoolConsignee.ConsigneeAreaId = this.SchoolConsigneeList[i].ConsigneeArea
                            this.schoolConsignee.ConsigneeAddress = this.SchoolConsigneeList[i].ConsigneeAdress
                            this.schoolConsignee.Consignee = this.SchoolConsigneeList[i].Consignee
                            this.schoolConsignee.ConsigneeTel = this.SchoolConsigneeList[i].ConsigneeTel


                        }
                    }
                });
            });
        },
        //会销开课new 
        OpenClassApplyAdd() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/MeetOrder/OpenClassApplyAdd", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false
                util.doResult(this, res, () => {
                    this.loading = false;
                    this.$notify({
                        title: '成功',
                        message: '开课成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false
                    if (this.form.PackageId !== 10082) {
                        // 开课跳转
                        this.$router.push("/Order/SchoolOrder/MeetOpenClassOrder");
                    }
                    this.initData();
                });
            });
        },

        //会销相关订单修改提交
        OpenClassApplyModify() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/MeetOrder/OpenClassApplyModify", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });

                    this.AddDialogVisible = false
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/openClassDialog/services.js